{
  "components": {
    "TutorialCard": {
      "revisit_tutorial": "Revisit Tutorial",
      "start_tutorial": "Start Tutorial",
      "completed": "Completed"
    }
  },
  "pages": {
    "TutorialDetail": {
      "tutorial_not_found": "Tutorial not found",
      "the_tutorial_youre_looking_for_doesnt": "The tutorial you're looking for doesn't exist.",
      "back_to_tutorials": "Back to Tutorials",
      "mark_as_incomplete": "Mark as Incomplete",
      "mark_as_complete": "Mark as Complete",
      "previous": "Previous:",
      "next": "Next:",
      "tutorial_steps": "Tutorial Steps",
      "of": "of",
      "steps_completed": "steps\n                completed"
    },
    "Tutorials": {
      "tutorials": "Tutorials",
      "total_tutorials": "Total Tutorials",
      "completed_tutorials": "Completed Tutorials",
      "learning_progress": "Learning Progress",
      "all": "All",
      "not_completed": "Not Completed",
      "attrs": {
        "search_tutorials": "Search tutorials"
      },
      "no_tutorials_found": "No tutorials found",
      "try_adjusting_your_search_or_filters": "Try adjusting your search or filters"
    }
  }
}
